// extracted by mini-css-extract-plugin
module.exports = {"copy":"Copy_copy__2PfKG","copy-text":"Copy_copy-text__11btm"};